import React, { PropsWithChildren } from 'react';
import { Space } from 'antd';

type Props = {
  size?: 'large' | 'small';
};

export const ButtonGroup = ({ children, size }: PropsWithChildren<Props>) => {
  const spaceSize = size === 'large' ? 'middle' : 'small';

  return <Space size={spaceSize}>{children}</Space>;
};
